var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"70d15f30fd2a9ea81b0f3e3e244fda5b3a36a222"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["payex-web@flywire"]={id:"70d15f30fd2a9ea81b0f3e3e244fda5b3a36a222"};
      